<template>
  <section>
    <region-list :query="query" />
  </section>
</template>

<script>
import RegionList from '@/components/basic/RegionList'

export default {
  name: 'Regions',
  components: {
    RegionList
  },

  data() {
    const { query } = this.$route

    return {
      query: query
    }
  },
  beforeRouteUpdate(to, from, next) {
    if (to.name === from.name) {
      this.query = to.query
    }

    next()
  }
}
</script>
